// extracted by css-extract-rspack-plugin
export default {"text":"text--YR7qDsgqYR0buIeq","multiline":"multiline--CwaN0MAZQOURGQDA"};